import axios from 'axios'
import fetch from '@/utils/fetch'
// const apiConfig = require('../../static/config.json')
const fileLoadPath =window.Glob.BASE_URL;
const apiUrl = window.Glob.BASE_URL;


//项目类型
export function getProjectTypeList(data) {
  return fetch({
    url: apiUrl + '/api/Project/GetProjectTypeList',
    method: 'post',
    data
  })
}
export function createProjectType(data) {
  return fetch({
    url: apiUrl + '/api/Project/CreateProjectType',
    method: 'post',
    data
  })
}
export function updateProjectType(data) {
  return fetch({
    url: apiUrl + '/api/Project/UpdateProjectType',
    method: 'post',
    data
  })
}
export function removeProjectType(data) {
  return fetch({
    url: apiUrl + '/api/Project/RemoveProjectType?id='+data,
    method: 'post'
  })
}
export function getProjectType(data) {
  return fetch({
    url: apiUrl + '/api/Project/GetProjectType?id='+data,
    method: 'post'
  })
}
//项目类型结束


//项目维护
export function getProjectList(data) {
  return fetch({
    url: apiUrl + '/api/Project/GetProjectList',
    method: 'post',
    data
  })
}

export function createProject(data) {
  return fetch({
    url: apiUrl + '/api/Project/CreateProject',
    method: 'post',
    data
  })
}

export function updateProject(data) {
  return fetch({
    url: apiUrl + '/api/Project/UpdateProject',
    method: 'post',
    data
  })
}

export function removeProject(data) {
  return fetch({
    url: apiUrl + '/api/Project/RemoveProject?id='+data,
    method: 'post'
  })
}

export function recoverProject(data) {
  return fetch({
    url: apiUrl + '/api/Project/RecoverProject?id='+data,
    method: 'post'
  })
}

export function getProject(data) {
  return fetch({
    url: apiUrl + '/api/Project/GetProject?id='+data,
    method: 'post'
  })
}
//项目维护结束


//任务类别维护

export function getProjectTaskList(data) {
  return fetch({
    url: apiUrl + '/api/Project/GetProjectTaskList',
    method: 'post',
    data
  })
}

export function createProjectTask(data) {
  return fetch({
    url: apiUrl + '/api/Project/CreateProjectTask',
    method: 'post',
    data
  })
}

export function updateProjectTask(data) {
  return fetch({
    url: apiUrl + '/api/Project/UpdateProjectTask',
    method: 'post',
    data
  })
}

export function removeProjectTask(data) {
  return fetch({
    url: apiUrl + '/api/Project/RemoveProjectTask?id='+data,
    method: 'post'
  })
}

export function recoverProjectTask(data) {
  return fetch({
    url: apiUrl + '/api/Project/RecoverProjectTask?id='+data,
    method: 'post'
  })
}

export function getProjectTask(data) {
  return fetch({
    url: apiUrl + '/api/Project/GetProjectTask?id='+data,
    method: 'post'
  })
}

//任务类别维护结束




// WEBPACK FOOTER //
// ./src/api/projectApi.js